module.exports = __webpack_public_path__ + "static/media/test.1db4c56c.svg";